import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { OrtsService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [OrtsService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class OrtsServiceModule {}
